import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/common/atoms/button';

import Styles from './Error.module.scss';

type ErrorType = {
	title: string;
	content: string;
	onReload?: () => void;
};

const Error: React.FC<ErrorType> = ({ title, content, onReload }) => {
	const { t } = useTranslation();

	return (
		<div className={Styles.container}>
			<p className={Styles.title}>{title}</p>
			<p className={Styles.subtitle}>{content}</p>
			{onReload && (
				<Button buttonStyle={'secondary'} onClick={onReload} small>
					{t('reload')}
				</Button>
			)}
		</div>
	);
};

export default Error;
